"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const checkVersion = (targetVersion, minVersion) => {
  if (void 0 === targetVersion) return !1;
  for (var n = 0, r = minVersion.length; n < r; n++) {
    var i = minVersion[n],
      o = parseInt(targetVersion[n], 10);
    if (isNaN(o) && (o = 0), o > i) return !0;
    if (o < i) return !1;
  }
  return !0;
};
const extractSystemInfo = e => {
  var supportedSystemRegEx = /\((iPhone|iPad|(?:iPod(?:\x20touch)?));.*\x20((?:\d[_.]{0,1})+)[^)]*\)\x20/i;
  var t = supportedSystemRegEx.exec(e);
  return t ? {
    type: t[1],
    version: function (e) {
      var t = [],
        n = /(\d+)/g,
        r = null;
      do {
        if (r = n.exec(e)) {
          var i = parseInt(r[0], 10);
          if ("number" != typeof i) return null;
          t.push(i);
        }
      } while (r);
      return t;
    }(t[2])
  } : null;
};
const checkAbcSupport = () => {
  var userAgent = window !== undefined && window.navigator && window.navigator.userAgent || "";
  var sysInfo = extractSystemInfo(userAgent);
  if (!sysInfo) {
    return false;
  }
  const minIOSVersion = [11, 3];
  const isIosDevice = ["IPHONE", "IPAD", "IPOD", "IPOD TOUCH"].includes(sysInfo.type.toUpperCase());
  return isIosDevice ? checkVersion(sysInfo.version, minIOSVersion) : false;
};
var _default = checkAbcSupport;
exports.default = _default;